import {useEffect, useMemo, useState} from "react";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import Table from "../../components/Table/Table";
import Avatar from "../../components/Avatar/Avatar"
import Icon, { plusIcon, userIcon} from "../../components/Icon/Icon";
import UserModal from "./UserModal";
import Button from "../../components/Button/Button";
import Actions from "../../components/Actions/Actions";
import {useNotification} from "../../hooks/useNotification";
import PageLayout from "../../components/PageLayout/PageLayout";
import {capitalize} from "../../utils/Utils";
import UserActions from "../../api/UsersActions";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [modal, setModal] = useState(null);
    const [deleteModal, setDeleteModal] = useState(null);
    const {triggerNotification} = useNotification()

    useEffect(() => {
        UserActions.loadUsers(setUsers)
    }, []);


    const columns = useMemo(() => [
        {
            accessorKey: 'name',
            header: 'Name',
            cell: ({row}) => {
                const {name, surname, color, image} = row.original;

                return (
                    <div>
                        <Avatar
                            name={name}
                            surname={surname}
                            url={image?.url}
                            color={color}
                        />
                        {name} {surname}
                    </div>
                )
            }
        },
        {
            accessorKey: 'email',
            header: 'Email',
        },
        {
            accessorKey: 'role',
            header: 'Role',
            cell: ({row}) => {
                const role = row.original.role;
                return (
                    <p className="role">{capitalize(role)}</p>
                )
            }
        },
        {
            accessorKey: 'actions',
            header: 'Actions',
            cell: ({row}) => {
                const role = row.original.role;
                return (
                    <Actions
                        onEdit={() => setModal(row.original)}
                        {...(role !== 'superadmin' && {onDelete: () => setDeleteModal(row.original)})}
                    />
                );
            }
        },
    ], [users]);


    return (
        <PageLayout
            titlePage="Users"
            icon={userIcon}
            actions={
                <Button className="add" onClick={() => setModal({})}>
                    <Icon svg={plusIcon}/> Add New
                </Button>
            }
        >
            <Table data={users} columns={columns}/>

            {
                deleteModal &&
                <DeleteModal
                    onClose={() => setDeleteModal(null)}
                    onConfirm={() => UserActions.deleteUser(deleteModal.id, () => {
                        setUsers(users.filter(user => user.id !== deleteModal.id));
                        triggerNotification('User deleted successfully');
                        setDeleteModal(null);
                    })}
                    title="Deleting user"
                    message={`Are you sure you want to delete user "${deleteModal?.name} ${deleteModal?.surname || ''}"?`}
                />
            }

            {modal && (
                <UserModal
                    onClose={() => setModal(null)}
                    onSubmit={values => {
                        if(!values.id){
                            UserActions.registerUser(values, res => {
                                setUsers([...users, res]);
                                setModal(null);
                                triggerNotification('User added successfully');
                            })
                        }else{
                            UserActions.updateUser(values.id, values, res => {
                                setUsers(users.map(user => user.id === values.id ? res : user));
                                setModal(null);
                                triggerNotification('User updated successfully');
                            })
                        }
                    }}
                    user={modal}
                />
            )}
        </PageLayout>
    )
}

export default Users;